import { render } from "./ScenarioGame.vue?vue&type=template&id=3875c214&scoped=true"
import script from "./ScenarioGame.vue?vue&type=script&lang=js"
export * from "./ScenarioGame.vue?vue&type=script&lang=js"

import "./ScenarioGame.vue?vue&type=style&index=0&id=3875c214&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3875c214"]])

export default __exports__